import { requirejs } from './require';
import { useTracker } from '~/composables/tracker';
import { setSpinnerVisibility } from '~/composables/loadingSpinner';
import { useTranslations } from '~/composables/translations';

const tracker = useTracker();
const { promise, $i18n } = useTranslations('loading_spinner');

/**
 * Export the user to MyApps call wrapper
 * @param username The user to export
 */
const exportUser = async (username: string) =>
  new Promise(async (resolve, reject) => {
    const [WAFData, MP3DPData]: any = await requirejs([
      'DS/WAFData/WAFData',
      'DS/MP3DPApplicationStore/MP3DPData',
    ]);
    const myAppsUrl = await MP3DPData._getServiceUrl('3DCompass');

    WAFData.authenticatedRequest(`${myAppsUrl}/resources/AppsMngt/user/public`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
      type: 'json',
      method: 'POST',
      data: {
        platform: MP3DPData.getTenant(),
        user: username,
        roles: 'MPU,PRB,UAU',
      },
      onComplete(res: any) {
        if (res && res.code === 0) {
          resolve(true);
        } else {
          console.log('My Apps call failed');
          resolve(true);
        }
      },
      onFailure(e: Error) {
        reject(e);
      },
    });
  });

/**
 * Export the user to MyApps, and adds a loading screen when the user just created his account + add Tracking
 * @param username The user to export
 * @param isNewUser returns true if the user just created his account
 */
async function exportUserToMyApps(username: string, isNewUser: boolean) {
  if (username) {
    if (isNewUser) {
      tracker?.event('MAIN_USER_CREATED', 'Event', 'Account', [username]);
      await promise;
      await setSpinnerVisibility(true, $i18n('registeringYourAccount'));
    }

    await exportUser(username);
    await setSpinnerVisibility(false);
  } else {
    tracker?.event('ERROR:MAIN_USER_LOGIN_OR_SIGNUP_FAIL', 'ERROR', 'Account');
  }
}

export { exportUserToMyApps };
